module.exports = __webpack_public_path__ + "img/li.fb3eed41.svg";